module.exports = __webpack_public_path__ + "static/media/25114629_1545557735493862_936959943_n_edited.d7b8d7b7.jpg";